"use strict";require("./observer");require("./redluom");require("./trier");